// import components
import { Box, Button, Typography } from '@mui/material';
import { Icon } from '@sdb/planning-ui';
import MenuButton from 'components/shared/MenuButton';
import ExecutedActions from './components/ExecutedActions';
import ServicedeskProcedureDrawer from './components/ServicedeskProcedureDrawer';
import {
  StyledPage,
  StyledPageContainer,
  StyledProcedureDescription,
  StyledProcedureRow,
  StyledProcedureWarning,
  StyledProcedureWarningText
} from './Servicedesk.styles';

// import hooks
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

// import types
import type { ProcedureCode, ServicedeskPage } from './Servicedesk.types';

const PROCEDURE_CODES: ProcedureCode[] = [
  'REVERT_REALIZATION',
  'IMPORT_HOURS_BALANCE'
];
const PAGES: ServicedeskPage[] = ['actions', 'history'];

const Servicedesk = () => {
  const { t } = useTranslation();
  const [page, setPage] = useState<ServicedeskPage>('actions');
  const [selectedProcedureCode, setSelectedProcedureCode] =
    useState<ProcedureCode | null>(null);

  const pageOptions = PAGES.map((value) => ({
    label: t(`adminPortal.servicedesk.pages.${value}`),
    onClick: () => setPage(value)
  }));

  return (
    <Box>
      <MenuButton
        label={t(`adminPortal.servicedesk.pages.${page}`)}
        options={pageOptions}
      />

      <StyledPageContainer>
        <StyledPage hidden={page !== 'actions'}>
          {PROCEDURE_CODES.map((code) => (
            <StyledProcedureRow key={code}>
              <Box>
                <Typography variant="subtitle1">
                  {t(`adminPortal.servicedesk.procedures.${code}.name`)}
                </Typography>
                <StyledProcedureDescription
                  variant="body2"
                  color="text.secondary"
                >
                  {t(`adminPortal.servicedesk.procedures.${code}.description`)}
                </StyledProcedureDescription>
                <StyledProcedureWarning>
                  <Icon
                    type="triangle-exclamation"
                    color="warning"
                    fontSize="small"
                  />
                  <StyledProcedureWarningText variant="body2">
                    {t(`adminPortal.servicedesk.procedures.${code}.warning`)}
                  </StyledProcedureWarningText>
                </StyledProcedureWarning>
              </Box>
              <Button
                variant="tonal"
                startIcon={<Icon type="play" />}
                onClick={() => setSelectedProcedureCode(code)}
              >
                {t('adminPortal.servicedesk.procedureList.open')}
              </Button>
            </StyledProcedureRow>
          ))}
        </StyledPage>

        <StyledPage hidden={page !== 'history'}>
          <ExecutedActions />
        </StyledPage>
      </StyledPageContainer>

      <ServicedeskProcedureDrawer
        procedureCode={selectedProcedureCode}
        onClose={() => setSelectedProcedureCode(null)}
      />
    </Box>
  );
};

export default Servicedesk;
